import { fork} from 'redux-saga/effects';
import PoolService from './pool';

export default function* rootSaga() {
 yield fork(PoolService);
}